export const formatDate = (date: string) => {
  const dateObj = new Date(date);

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} at ${hours}:${minutes}`;
};

export const normalizeTimestampDate = (timestamp: number | string) => {
  const date = new Date(timestamp);

  if (date.getFullYear() < 1980 && typeof timestamp === 'number') {
    date.setTime(timestamp * 1000);
  }

  return date;
};
